"use strict";

exports.__esModule = true;
exports.CheckableButton = CheckableButton;

var _reactUtils = require("@okee-uikit/react-utils");

var _react = _interopRequireWildcard(require("react"));

var _reactConfig = require("@okee-uikit/react-config");

var _Button = require("./Button");

var _excluded = ["onChange", "className", "checked", "onClick"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function CheckableButton(props) {
  var onChange = props.onChange,
      className = props.className,
      checked = props.checked,
      onClick = props.onClick,
      extra = _objectWithoutPropertiesLoose(props, _excluded);

  var cls = (0, _reactUtils.classnames)((0, _reactConfig.usePrefixCls)('btn', {
    checked: checked
  }), className);
  var onButtonClick = (0, _react.useCallback)(function (e) {
    onClick && onClick(e);
    onChange(!checked);
  }, [onChange, onClick, checked]);
  return _react.default.createElement(_Button.Button, _extends({}, extra, {
    className: cls,
    onClick: onButtonClick,
    type: "primary",
    plain: true
  }));
}